import { render, staticRenderFns } from "./MLBView.vue?vue&type=template&id=5ca079ff&scoped=true&"
import script from "./MLBView.vue?vue&type=script&lang=ts&"
export * from "./MLBView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca079ff",
  null
  
)

export default component.exports